/**
 * Client-side entry point for providers.
 *
 * This file uses the 'use client' directive to mark all exported components
 * as Client Components for the Next.js App Router. This is essential for
 * any provider that uses client-side hooks like `createContext` or `useState`.
 *
 * Import from this entry point (e.g., '@frnt/base/providers/client') to ensure
 * compatibility with Server Components, which cannot directly import components
 * that use client-side-only APIs.
 */
'use client'

export * from './lib/chakra-provider-with-theme'
